// extracted by mini-css-extract-plugin
module.exports = {"default":"f_f","image":"f_r","textContainer":"f_S","heading1":"f_T","heading2":"f_V","animatedElement":"f_W","homeAnimated":"f_X","aboutAnimated":"f_Y"};